export const DEFAULT_ALLOW_DISCOUNT_COMBINATION = true;
